<script setup>
import { useCommonImports } from '~/common/composables/common-imports.composable.js';

const { $t } = useCommonImports();
</script>

<template>
  <div class="flex min-h-full flex-col">
    <HawkPageHeader :title="$t('Photos')" />
    <div class="px-4 flex-1">
      <router-view />
    </div>
  </div>
</template>
